import React from 'react';

const StatusDot = ({ status }) => {
  const statusClass = `status-dot status-${status}`
  return <span className={statusClass} />
}

export default StatusDot;

